import {useQuery} from '@tanstack/react-query';
import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';
import {getInvoices} from '../../services/getInvoices';

export const useGetInvoicesQuery = (enabled: boolean) =>
	useQuery({
		queryKey: [QUERY_KEYS.OPEN_BILLS_INVOICES],
		queryFn: async ({signal}) => getInvoices({signal}),
		enabled,
		retry: 2,
	});
